var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2393 21.3402L19.3427 3.68585C18.2818 1.78849 16.783 0.75 15.1382 0.75C13.4935 0.75 11.9722 1.81095 10.9225 3.68585L0.992296 21.3402C-0.0686498 23.2207 -0.186533 25.0563 0.655487 26.5046C1.49751 27.9529 3.1591 28.75 5.3259 28.75H24.9057C27.0669 28.75 28.7228 27.9529 29.5705 26.5046C30.4181 25.0563 30.3002 23.2207 29.2393 21.3402Z",
    fill: "#BB0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.116 20.4927C14.2758 20.4927 13.5947 21.1738 13.5947 22.0139C13.5947 22.8541 14.2758 23.5352 15.116 23.5352C15.9561 23.5352 16.6372 22.8541 16.6372 22.0139C16.6372 21.1738 15.9561 20.4927 15.116 20.4927L15.116 20.4927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.116 9.47339C14.2802 9.47337 13.6009 10.1476 13.5947 10.9834C13.5947 11.0283 13.5947 11.0732 13.5947 11.1125L14.201 18.4774C14.201 18.9765 14.6056 19.3812 15.1048 19.3812C15.6039 19.3812 16.0085 18.9765 16.0085 18.4774V18.4774L16.6148 11.1125C16.6148 11.0732 16.6148 11.0283 16.6148 10.9834C16.6058 10.1575 15.9418 9.48852 15.116 9.47339L15.116 9.47339Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.d30416bf11f89e2e05f13d18dac6728f.svg";
export { ForwardRef as ReactComponent };